import add from '../assets/svg/add.svg';
import america from '../assets/svg/america.svg';
import appleStore from '../assets/svg/apple-store.svg';
import arrowDown from '../assets/svg/arrowDown.svg';
import arrowLeft from '../assets/svg/arrowleft.svg';
import arrowRight from '../assets/svg/arrowright.svg';
import arrowUp from '../assets/svg/arrowup.svg';
import ball from '../assets/svg/ball.svg';
import amex from '../assets/svg/bd-amex.svg';
import dinersclub from '../assets/svg/bd-dinersclub.svg';
import discover from '../assets/svg/bd-discover.svg';
import elo from '../assets/svg/bd-elo.svg';
import hipercard from '../assets/svg/bd-hipercard.svg';
import jcb from '../assets/svg/bd-jcb.svg';
import maestro from '../assets/svg/bd-maestro.svg';
import mastercard from '../assets/svg/bd-mastercard.svg';
import visa from '../assets/svg/bd-visa.svg';
import biometrics from '../assets/svg/biometrics.svg';
import brazil from '../assets/svg/brazil.svg';
import close from '../assets/svg/close.svg';
import coupon from '../assets/svg/coupon.svg';
import emptyResale from '../assets/svg/emptyResale.svg';
import emptyTickets from '../assets/svg/emptyTickets.svg';
import emptyTicketsFutebol from '../assets/svg/emptyTicketsFutebol.svg';
import errorX from '../assets/svg/error-x.svg';
import faceNaming from '../assets/svg/face-naming.svg';
import face from '../assets/svg/face.svg';
import icInfoPayment from '../assets/svg/ic_info.svg';
import check from '../assets/svg/ic-check.svg';
import icCopy from '../assets/svg/ic-copy.svg';
import icEmail from '../assets/svg/ic-email.svg';
import icInfo from '../assets/svg/ic-info.svg';
import icLocation from '../assets/svg/ic-location.svg';
import icTag from '../assets/svg/ic-tag.svg';
import illustrationHand from '../assets/svg/illustrationHand.svg';
import info from '../assets/svg/info.svg';
import logo from '../assets/svg/logo.svg';
import minus from '../assets/svg/minus.svg';
import more from '../assets/svg/more.svg';
import oGlobo from '../assets/svg/o-globo.svg';
import partner from '../assets/svg/partner.svg';
import placeIcon from '../assets/svg/place.svg';
import playStore from '../assets/svg/play-store.svg';
import portugal from '../assets/svg/portugal.svg';
import released from '../assets/svg/released.svg';
import remove from '../assets/svg/remove.svg';
import spain from '../assets/svg/spain.svg';
import summary from '../assets/svg/summary.svg';
import support from '../assets/svg/support.svg';
import warningTicket from '../assets/svg/warning_ticket.svg';
import warning from '../assets/svg/warning.svg';
import { AppLocale } from '../i18n/locale';

type Svg = {
  arrowDown: string;
  arrowUp: string;
  placeIcon: string;
  summary: string;
  illustrationHand: string;
  logo: string;
  info: string;
  arrowRight: string;
  arrowLeft: string;
  coupon: string;
  support: string;
  emptyTickets: string;
  emptyTicketsFutebol: string;
  emptyResale: string;
  partner: string;
  released: string;
  biometrics: string;
  icInfo: string;
  ball: string;
  close: string;
  more: string;
  minus: string;
  add: string;
  remove: string;
  face: string;
  faceNaming: string;
  icTag: string;
  icEmail: string;
  errorX: string;
  warning: string;
  icLocation: string;
  appleStore: string;
  playStore: string;
  warningTicket: string;
  icInfoPayment: string;
  icCopy: string;
  oGlobo: string;
  hipercard: string;
  elo: string;
  discover: string;
  dinersclub: string;
  amex: string;
  jcb: string;
  visa: string;
  maestro: string;
  mastercard: string;
  check: string;
}

/**
 * Flags per locale, keyed by the BCP-47 tag the app resolves to.
 *
 * The keys used to be the underscore spellings (`pt_br`), which meant every
 * consumer had to rebuild the key with `currentLocale.locale.replace('-', '_')`
 * — four call sites doing the same transformation on an already-canonical
 * value, and any locale outside the three gave `undefined` and a broken image.
 * Derived from `AppLocale` so a new language fails to compile here instead of
 * rendering an empty flag.
 */
export type CountryImages = Record<AppLocale, string>;

type Images = {
  countries: CountryImages;
  svg: Svg;
}

export const ImagesApp: Images = {
  countries : {
    'pt-BR' : brazil,
    'pt-PT' : portugal,
    'en-US' : america,
    'es-ES' : spain,
  },
  svg : {
    arrowDown,
    placeIcon,
    summary,
    illustrationHand,
    logo,
    info,
    arrowRight,
    arrowLeft,
    arrowUp,
    coupon,
    support,
    emptyTickets,
    emptyTicketsFutebol,
    emptyResale,
    partner,
    released,
    biometrics,
    icInfo,
    ball,
    close,
    more,
    minus,
    add,
    remove,
    face,
    faceNaming,
    icTag,
    icEmail,
    errorX,
    warning,
    icLocation,
    appleStore,
    playStore,
    warningTicket,
    icInfoPayment,
    icCopy,
    oGlobo,
    hipercard,
    elo,
    discover,
    dinersclub,
    amex,
    jcb,
    visa,
    maestro,
    mastercard,
    check,
  }
};

export const avatarDefaultUrl = 'https://dpz4c7q921os3.cloudfront.net/images/friends-list/user_no_picture.png';
